module.exports = __webpack_public_path__ + "static/media/successful-partnerships-bg.6f3fa078.webp";